import { Typography } from '@/components/ui/typography'
import { cn } from '@/lib/utils'

export type FieldMetaErrors = Partial<Record<string, { errors?: readonly unknown[] }>>

const getFormErrorMessage = (error: unknown) => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return error.message
  }

  return String(error)
}

export const getFormErrorMessages = (errors: readonly unknown[] = []) =>
  errors.map(getFormErrorMessage).filter((message) => message.trim().length > 0)

export const getFieldErrorMessages = (
  fieldMeta: FieldMetaErrors | null | undefined,
  fieldName: string
) => getFormErrorMessages(fieldMeta?.[fieldName]?.errors ?? [])

export type InlineFieldErrorsProps = {
  errors?: readonly unknown[]
  id?: string
  className?: string
}

export default function InlineFieldErrors({ errors = [], id, className }: InlineFieldErrorsProps) {
  const messages = getFormErrorMessages(errors)

  if (!messages.length) {
    return null
  }

  return (
    <Typography
      variant="caption"
      tone="destructive"
      id={id}
      role="alert"
      className={cn('block', className)}
    >
      {messages.join(' ')}
    </Typography>
  )
}
